export default {
  BusinessStockComDialogOrder: {
    queryCode: 'Order No.',
    planNum: 'Available Inventory',
    platformOrderCode: 'Customer Order No.',
    orderCode: 'CSG Order No.',
    orderCreationDate: 'Third-Party Ordering Time',
    stockoutQty: 'Out-of-Stock Quantity',
    scheduledDeliveryTime: 'Expected Shipping Time',
    replenishQty: 'Replenishment Quantity',
    priorityGrade: 'Priority',
    msgWaring1: 'The sum of replenishment quantity cannot be greater than available inventory',
    msgWaring2: 'Please enter  the order',
    msgWaring3: 'the priority of',
  }
};
